import { money2 } from "@/lib/format";

export function itemSizeOptions(item) {
  if (!item) return [];
  return [
    { key: "small", label: "Small", price: item.smallPrice },
    { key: "medium", label: "Medium", price: item.mediumPrice },
    { key: "large", label: "Large", price: item.largePrice },
  ].filter((s) => s.price != null && !Number.isNaN(Number(s.price)));
}

export function itemHasSizes(item) {
  return itemSizeOptions(item).length > 0;
}

export function itemPosPriceLabel(item) {
  const sizes = itemSizeOptions(item);
  if (!sizes.length) {
    return money2(item?.price || 0);
  }
  const prices = sizes.map((s) => Number(s.price));
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  if (min === max) return money2(min);
  return `${money2(min)}–${money2(max)}`;
}
